module.exports = "<input [readonly]=\"true\" class=\"form-control-xs\"  name=\"currencyInput\" value=\"{{formattedInputValue}}\">";